import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ginkgo/Desktop/comverse /comverse-baseapp-next/components/Vertica/Vertica.jsx");
